import Button from '@blocks/Button';
import EmphasizedContent from '@blocks/EmphasizedContent';
import Grid from '@blocks/Grid';
import useSidepanel from '@hooks/useSidepanel';
import { CardElement, Elements, useElements, useStripe } from '@stripe/react-stripe-js';
import { loadStripe, StripeError } from '@stripe/stripe-js';
import { colors } from '@styles/vars';
import React, { useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as MastercardLogo } from '../images/mastercard.svg';
import VisaLogo from '../images/visa.png';

const stripePromise = loadStripe(process.env.MIX_STRIPE_KEY as string)

export default function Stripe({ salon, promo }: Props) {
    return (
        <Elements stripe={stripePromise}>
            <StripeForm salon={salon} promo={promo} />
        </Elements>
    )
}

function StripeForm({ salon, promo }: Props) {
    const [error, setError] = useState<React.ReactNode>(null)
    const sidepanel = useSidepanel()
    const stripe = useStripe()
    const elements = useElements()

    const handleSubmit = async (event: any) => {
        event.preventDefault()

        try {
            await salon.actions.payment.stripe(stripe, elements, promo)
            sidepanel.close()
        } catch (error: unknown) {
            if (isStripeError(error))
                setError(error.message)
            else
                console.log(error)
        }
    }

    const clear = () => {
        setError(undefined)
    }

    return (
        <form onSubmit={handleSubmit}>
            <Grid gap="15px">
                <Grid gap="5px">
                    <EmphasizedContent padding="10px" background="white">
                        <CardElement
                            onChange={clear}
                            options={{
                                style: {
                                    base: {
                                        fontSize: "16px",
                                        color: colors.black
                                    },
                                    invalid: {
                                        color: colors.error,
                                    }
                                },
                            }}
                        />
                    </EmphasizedContent>
                    {error && <small style={{ color: colors.error }}>{error}</small>}
                </Grid>
                <Button element="submit">Pay €{promo?.fee || salon.state.fee}</Button>
                <LogosWrapper><MastercardLogo /><img src={VisaLogo} /></LogosWrapper>
            </Grid>
        </form>
    )
}

interface Props {
    salon: Customer.Models.Salon.Stateful
    promo: Customer.States.Promo | undefined
}

const isStripeError = (x: any): x is StripeError => {
    return typeof x.type === 'string' && typeof x.code === "string" && typeof x.message === "string";
}

const LogosWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;

    *:not(:last-child) {
        margin-right: 5px;
    }

    svg {
        max-height: 24px;
        width: auto;
    }

    img {
        max-height: 24px;
    }
`